import {isEmpty} from 'lodash';
import React from 'react';
import {color, type} from 'common/tokens';
import MTMarkdown from "../MTMarkdown";

// Every question used to render `id="helpText"`, so a page with more than one
// carried duplicate ids and nothing could point at a single one.
const QuestionHelpText = ({helpText, id}) => {
  if (isEmpty(helpText)) return null;

  return (
    <div id={id}>
      <MTMarkdown style={{
        ...type.meta,
        fontWeight: 'var(--ui-weight-regular)',
        color: color.TEXT_MUTED,
        marginTop: 6,
        marginBottom: 0,
      }}>{helpText}</MTMarkdown>
    </div>
  );
};

export default QuestionHelpText;
